import { z } from 'zod';

export const AssetStatus = z.enum(['active', 'maintenance', 'decommissioned']);
export type AssetStatus = z.infer<typeof AssetStatus>;

export const AssetSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  type: z.string(), // e.g., HVAC, Plumbing, Electrical
  status: AssetStatus,
  make: z.string().nullable(),
  model: z.string().nullable(),
  serialNumber: z.string().nullable(),
  location: z.string(),
  buildingId: z.string().nullable(),
  parentAssetId: z.string().uuid().nullable(),
  installedAt: z.string().datetime().nullable(),
  warrantyExpiresAt: z.string().datetime().nullable(),
  qrCode: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  // External identity
  orgId: z.string().nullable().optional(),
  siteId: z.string().nullable().optional(),
  externalSystem: z.string().nullable().optional(),
  externalId: z.string().nullable().optional(),
  externalRefId: z.string().nullable().optional(),
});

export type Asset = z.infer<typeof AssetSchema>;
